import { render, staticRenderFns } from "./AppRadio.vue?vue&type=template&id=3a8df376&"
import script from "./AppRadio.vue?vue&type=script&lang=ts&"
export * from "./AppRadio.vue?vue&type=script&lang=ts&"
import style0 from "./AppRadio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio})
